import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import AccountStatusDialog from "../../components/element/AccountStatusDialog";
import { REJECT_STATUS_MESSAGE } from "../../utils/constants";
import ROUTE_PATHS from "../../utils/routePaths";
import "./CommercialAirlineHome.css";
import GridComponent from "./Views/GridComponent";
import { useFormData } from "../../helpers/FormDataProvider";
import CommercialAirlineNavigationBar from "../../components/element/CommercialAirlineNavigationBar";
import { getServiceUrls } from "../../services/serviceUrls";
import VersioningComponent from "./Views/VersioningComponent";
import VersionNotification from "../../components/element/VersionNotification";
import { StorageContext } from "../../services/StorageProvider";

const CommercialAirlineHome = () => {
  const navigate = useNavigate();
  const { userData } = useFormData();
  const { userProfileData } = useContext(StorageContext);
  const [showStatusDialog, setShowStatusDialog] = useState(false);
  const [statusTitle, setStatusTitle] = useState(false);
  const SERVICE_URLS = getServiceUrls();
  const [isVersionDialogOpen, setIsVersionDialogOpen] = useState(false);
  const [showVersionModal, setShowVersionModal] = useState(false);

  const handleCardOnClick = (index) => {
    switch (index) {
      case 0:
        navigate(ROUTE_PATHS.COMMERCIAL_AIRLINE_INVOICE);
        break;
      case 2:
        navigate(ROUTE_PATHS.COMMERCIAL_AIRLINE_FLIGHT_ROSTER);
        break;
      case 3:
        navigate(ROUTE_PATHS.COMMERCIAL_AIRLINE_VIEW_SPECIAL_ONBOARDING);
        break;
      case 4:
        navigate(ROUTE_PATHS.COMMERCIAL_AIRLINE_DATA_SOURCE);
        break;
      case 5:
        navigate(ROUTE_PATHS.COMMERCIAL_AIRLINE_ACCOUNT_MAINTENANCE);
        break;
      case 6:
        navigate(ROUTE_PATHS.COMMERCIAL_AIRLINE_INVOICING_IATA);
        break;
      case 7:
        navigate(ROUTE_PATHS.COMMERCIAL_AIRLINE_CONCESSION_FEE);
        break;
      default:
        break;
    }
  };

  const handleDialogButtonClick = () => {
    setShowStatusDialog(false);
    setStatusTitle("");
    if (statusTitle === REJECT_STATUS_MESSAGE) {
      navigate(ROUTE_PATHS.COMMERCIAL_AIRLINE_ACCOUNT_MAINTENANCE);
    }
  };

  const handleVersionClick = () => {
    setShowVersionModal(true);
  };
  return (
    <div>
      <VersionNotification onVersionClick={handleVersionClick} />
      <VersioningComponent
        isOpen={showVersionModal}
        onClose={() => setShowVersionModal(false)}
      />
      <CommercialAirlineNavigationBar showHeaderBar={false} />
      <div className="commercial-airline-container">
        <GridComponent
          onClickCard={handleCardOnClick}
          userRole={
            userData.isOperationUser
              ? "AA_OPS_ROLE"
              : userData.isAAUser
              ? "AA_"
              : userProfileData?.role
          }
        />
        <AccountStatusDialog
          open={showStatusDialog}
          onClose={() => setShowStatusDialog(false)}
          title={statusTitle}
          handleClick={handleDialogButtonClick}
        />
      </div>
      {SERVICE_URLS.REACT_APP_VERSION && (
        <div className="version-info">
          <button
            onClick={() => setIsVersionDialogOpen(true)}
            className="version-button"
          >
            Version {SERVICE_URLS.REACT_APP_VERSION}
          </button>
          <VersioningComponent
            isOpen={isVersionDialogOpen}
            onClose={() => setIsVersionDialogOpen(false)}
            version={SERVICE_URLS.REACT_APP_VERSION}
          />
        </div>
      )}
    </div>
  );
};

export default CommercialAirlineHome;
